import React, { Component } from 'react';
import classnames from 'classnames';

/**
* Image properties  
*/
export interface IImageProps {
    /**
    * image url
    */
    src?: string;
    alt?: string;
    className?: string;
}

/**
* Image
*/
class Image extends Component<IImageProps> {
    static defaultProps: IImageProps = {
        src: '',
        alt: '',
        className: ''
    };

    render() {
        const { 
            src,
            alt,
            className,
            ...otherProps 
        } = this.props;

        const classes = classnames('lego-img', className);

        return <img src={src} alt={alt} className={classes} {...otherProps} />;
    }
}

export default Image;